import { render, staticRenderFns } from "./tableWrapper.vue?vue&type=template&id=b76145f8&"
import script from "./tableWrapper.vue?vue&type=script&lang=js&"
export * from "./tableWrapper.vue?vue&type=script&lang=js&"
import style0 from "./tableWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports